import { MdOutlineHome, MdOutlineSchedule } from "react-icons/md";
import { FaFileContract, FaIndianRupeeSign, FaList } from "react-icons/fa6";
import { IoIosDocument } from "react-icons/io";
import { CLAIM_AND_CHANGE_ORDER_DASH_ACCESS } from "config";
import { RISK_DASH_ACCESS } from "config";
import { SAFETY_DASH_ACCESS } from "config";
import { QUALITY_DASH_ACCESS } from "config";
import { ISSUES_DASH_ACCESS } from "config";
import { KEY_CLEATANCE_DASH_ACCESS } from "config";
import { PROCUREMENT_DASH_ACCESS } from "config";
import { VENDOR_DASH_ACCESS } from "config";
import { FINANCIAL_PROGRESS_DASH_ACCESS } from "config";
import { PAYMENT_TRACKER_DASH_ACCESS } from "config";
import { SMT_SCHEDULE_ACCESS } from "config";
import { SMT_CONSTRUCTION_ACCESS } from "config";
import { SMT_MILESTONE_ACCESS } from "config";
import { SMT_ENGINEERING_ACCESS } from "config";
import { SMT_PM_ACCESS } from "config";
import { SMT_MANPOWERPRODUCT_ACCESS } from "config";
import { PROJECT_HOME_ACCESS } from "config";
import { ReactComponent as HomeIcon} from "assets/PwC_Funct_Icons_Home_Outline_Black_RGB.svg";
import { ReactComponent as ScheduleView } from "assets/PwC_Funct_Icons_Time_Outline_Black_RGB.svg";
import {ReactComponent as ProcurementView} from "assets/PwC_Funct_Icons_Document_Fill_Black_RGB.svg"
import { ReactComponent as ChangeControl } from "assets/PwC_Funct_Icons_News_Fill_Black_RGB.svg";
import {ReactComponent as ProjectView} from "assets/PwC_Funct_Icons_Cost-Dollar_Outline_Black_RGB.svg"
import {ReactComponent as GovernanceView} from "assets/PwC_Funct_Icons_ListView_Fill_Black_RGB.svg"







const tabs = [
    { label: "Home", path: "project-landing", index: 0, icon: <HomeIcon style={{ fontSize: '20px',height: "20px", width: "20px",fill:"#696969",stroke:"#696969", strokeWidth:2 }} />, permissionKey: [PROJECT_HOME_ACCESS] },
    { label: "Project Progress and Scheduling", path: "schedule", index: 1, icon: <ScheduleView style={{ fontSize: '20px',height: "20px", width: "20px",fill:"#696969",stroke:"#696969", strokeWidth:2 }} />, permissionKey: [SMT_SCHEDULE_ACCESS, SMT_CONSTRUCTION_ACCESS, SMT_MILESTONE_ACCESS, SMT_ENGINEERING_ACCESS, SMT_PM_ACCESS, SMT_MANPOWERPRODUCT_ACCESS] },
    { label: "Project Cost Control", path: "cost", index: 2, icon: <ProjectView  style={{ fontSize: '20px',height: "20px", width: "20px",fill:"#696969",stroke:"#696969", strokeWidth:2 }}/>, permissionKey: [FINANCIAL_PROGRESS_DASH_ACCESS, PAYMENT_TRACKER_DASH_ACCESS] },
    { label: "Contract and Procurement Lifecycle", path: "procurement", index: 3, icon: <ProcurementView  style={{ fontSize: '20px',height: "20px", width: "20px", fill:"#696969" }}/>, permissionKey: [VENDOR_DASH_ACCESS, PROCUREMENT_DASH_ACCESS] },
    { label: "Change Control & Claim Tracker", path: "claims-and-changeorder", index: 4, icon: <ChangeControl  style={{ fontSize: '20px',height: "20px", width: "20px",fill:"#696969" }}/>, permissionKey: [CLAIM_AND_CHANGE_ORDER_DASH_ACCESS] },
    { label: " Governance and Compliance", path: "risk", index: 5, icon: <GovernanceView  style={{ fontSize: '20px',height: "20px", width: "20px", fill:"#696969" }}/>, permissionKey: [ISSUES_DASH_ACCESS, KEY_CLEATANCE_DASH_ACCESS, RISK_DASH_ACCESS, SAFETY_DASH_ACCESS, QUALITY_DASH_ACCESS] },
];

export default tabs